import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { Logger } from '@app/core/logger.service';
import { PDFGenerator } from '@awesome-cordova-plugins/pdf-generator/ngx';
import { environment } from '@env/environment';
declare var html2pdf: any;
import * as html2canvas from 'html2canvas';
import { Platform } from '@ionic/angular';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
import { IonLoaderService } from '@app/shared/services/ion-loader/ion-loader.service';
const log = new Logger('ProductsPDFComponent');

@Component({
  selector: 'app-i-pdf-products',
  templateUrl: './i-pdf-products.component.html',
  styleUrls: ['./i-pdf-products.component.scss'],
})
export class IPdfProductsComponent implements OnInit {
  isIndeterminate: boolean;
  masterCheck: boolean = false;
  products: any[] = [];
  public defaultImage: string = '';
  public isLoading: boolean = false;
  public html = '';
  sanitizedHtml: any;
  fileName: string = 'mis-productos.pdf';
  isWeb: boolean = true;
  public step: number = 1;
  public canContinue: boolean = false;
  private url_company_default_logo: string = '';
  private url_conectimed_logo: string = '';
  capturedImage: any;
  COMPANY_LOGO: any;
  COMPANY_NAME: any;
  APP_URL = environment.APP_URL;

  constructor(
    private fireService: FirebaseService,
    public credService: CredentialsService,
    private platform: Platform,
    private pdfGenerator: PDFGenerator,
    private sanitizer: DomSanitizer,
    private loader: IonLoaderService
  ) {
    this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
  }

  ngOnInit() {
    this.platform
      .ready()
      .then(async () => {
        if (this.platform.is('capacitor') === true) {
          this.isWeb = false;
          this.defaultImage = environment.APP_URL + '/assets/img/no-product.PNG';
          this.url_conectimed_logo = environment.APP_URL + '/assets/img/logo-horizontal.png';
          this.url_company_default_logo = environment.APP_URL + '/assets/img/white.png';
        } else {
          this.isWeb = true;
          this.defaultImage = '../../../assets/img/no-product.PNG';
          this.url_conectimed_logo = '../../../assets/img/logo-horizontal.png';
          this.url_company_default_logo = '../../../assets/img/white.png';
        }
        this.initProducts();
      })
      .catch(err => {
        log.error(err);
      });
  }

  private async initProducts() {
    this.isLoading = true;
    try {
      const RESP = await this.fireService.afs
        .collection('products')
        .ref.where('uid', '==', this.credService.credentials.uid)
        .where('status', '==', 'active')
        .orderBy('nameStr', 'asc')
        .get();
      this.products = RESP.docs.map(item => {
        let data: any = item.data();
        const ID: string = item.id;
        data.image = data.image ? String(data.image) : this.defaultImage;
        return { id: ID, ...data };
      });
    } catch (error) {
      log.error(error);
    }
    this.isLoading = false;
  }

  public async generate() {
    this.isLoading = true;
    try {
      const products = this.products.filter(item => {
        if (item && item.isChecked === true) {
          return true;
        } else {
          return false;
        }
      });
      let innerHtml: string = ``;
      for (const item of products) {
        let producto_sustancia_activa_1: string = '';
        let producto_sustancia_activa_2: string = '';
        let linea_terapeutica_1: string = '';
        let linea_terapeutica_2: string = '';
        let presentacion_1: string = '';
        let presentacion_2: string = '';

        if (item && item.producto_sustancia_activa_1) {
          producto_sustancia_activa_1 = `<p><small>${item.producto_sustancia_activa_1}</small></p>`;
        }

        if (item && item.producto_sustancia_activa_2) {
          producto_sustancia_activa_2 = `<p><small>${item.producto_sustancia_activa_2}</small></p>`;
        }

        if (item && item.linea_terapeutica_1) {
          linea_terapeutica_1 = `<p><small>${item.linea_terapeutica_1}</small></p>`;
        }

        if (item && item.linea_terapeutica_2) {
          linea_terapeutica_2 = `<p><small>${item.linea_terapeutica_2}</small></p>`;
        }

        if (item && item.presentacion_1) {
          presentacion_1 = `<p><small>${item.presentacion_1}</small></p>`;
        }

        if (item && item.presentacion_2) {
          presentacion_2 = `<p><small>${item.presentacion_2}</small></p>`;
        }

        let product: string = `
        <tr>
        <td style="vertical-align: middle; text-align: center; border-top: 4px solid #c9c9c9;">
          <img src="${item.image}" alt="${item.marca}" class="cstm-img-fluid" />
        </td>
        <td style="vertical-align: top;">
          <h2 class="cstm-title1">
            <small> ${item.marca}</small>
          </h2>
          <div class="cstm-main-content">
          ${producto_sustancia_activa_1}
          ${producto_sustancia_activa_2}
          ${linea_terapeutica_1}
          ${linea_terapeutica_2}
          ${presentacion_1}
          ${presentacion_2}
          </div>
        </td>
        <td style="vertical-align: top;">
          <div class="cstm-title2">${item.type}</div>
          <div class="cstm-orange-button">
            <a href="${environment.APP_URL}/multimedia/pharmaceutical-industry/products/${item.id}"
              >Información para prescribir</a
            >
          </div>
        </td>
      </tr>`;
        innerHtml = innerHtml + product;
      }
      const RESP2 = await this.fireService.afs.doc(`representante-meta/${this.credService.credentials.uid}`).ref.get();
      const META: any = RESP2.data();
      const RESP3 = await META.company.get();
      const COMPANY = RESP3.data();
      const COMPANY_LOGO = COMPANY && COMPANY.logo ? COMPANY.logo : this.url_company_default_logo;
      try {
        this.COMPANY_LOGO = await this.getImageData(COMPANY_LOGO);
      } catch (error) {
        log.error(error);
      }
      this.COMPANY_NAME = COMPANY.name;

      let footerMovil: string = '';
      let headerMovil: string = '';

      if (!(this.isWeb === true)) {
        headerMovil = `
        <tr>
          <td colspan="3">
            <div #header1 id="header1" style="background: url('https://firebasestorage.googleapis.com/v0/b/conectimed-9d22c.appspot.com/o/app%2Fgray-bg.png?alt=media&token=c6c5bb15-9d2c-496c-8383-ad45d24369de');">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
              <tbody>
                <tr>
                  <th colspan="2">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="width:55%">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                              <tbody>
                                <tr>
                                  <td colspan="2" style="text-align: left;">
                                    <div class="cstm-header1">
                                      MANTENGA CONTACTO CON SU REPRESENTANTE DANDO
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="text-align: left;">
                                    <div class="cstm-header3">
                                      <a href="${environment.APP_URL}/user/details/${this.credService.credentials.uid}"> CLICK AQUI</a>
                                    </div>
                                  </td>
                                  <td>
                                    &nbsp;
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td style="width:45%">
                            <h2 class="cstm-title">${COMPANY.name}</h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </th>
                  <th>
                    <div class="cstm-logo-wrapper">
                      <img
                        crossorigin="anonymous"
                        #logo
                        id="logo"
                        src="${COMPANY_LOGO}"
                        alt="${COMPANY.name}"
                        class="cstm-img-fluid"
                      />
                    </div>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
          </td>
        </tr>
        `;

        footerMovil = `
        <tr>
          <td colspan="3">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <td>
                    <div class="cstm-footer-wrapper1">
                      <img
                        src="${this.url_conectimed_logo}"
                        alt="Conectimed"
                        class="cstm-img-fluid"
                        style="margin: 0 0 !important; max-width: 150px;"
                      />
                    </div>
                  </td>
                  <td colspan="2">
                    <div class="cstm-footer">
                      <a href="${environment.APP_URL}"
                        >PRODUCTOS PUBLICADOS EN LA PLATAFORMA CONECTIMED: ${environment.APP_URL}</a
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>`;
      }

      this.html = ` 
      <!DOCTYPE html>
      <html lang="es">
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <title>My products</title>
            <style type="text/css">
                .main-container {
                    width: 595px;
                }

                /* New Products PDF Begin*/
                .cstm-main-content {
                    display: block;
                    position: relative;
                    max-width: 950px;
                    width: 100%;
                    margin: 0 auto;
                }

                .cstm-img-fluid {
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    width: 100%;
                    max-width: 250px;
                }

                .cstm-orange-button {
                    display: block;
                    position: relative;
                    text-decoration: none;
                    background-color: #ff9800;
                    color: white;
                    padding: 10px;
                    border-radius: 10px;
                    margin: 10px auto;
                    font-weight: bold;
                    text-align: center;
                    max-width: 125px;
                    margin-top: 25%;
                }

                .cstm-orange-button a {
                    text-decoration: none;
                    color: white;
                }

                .cstm-title {
                    color: #0e518b;
                    font-weight: bold;
                    padding: 0 15px;
                }

                .cstm-title1 {
                    display: block;
                    position: relative;
                    margin: 0;
                    padding: 8px;
                    background-color: #0e518b;
                    color: white;
                    font-weight: bold;
                    border-radius: 0px 0px 15px 15px;
                    overflow: hidden;
                    text-align: center;
                    text-transform: uppercase;
                }

                .cstm-title2 {
                    background-color: #c9c9c9;
                    text-align: center;
                    padding: 5px;
                    font-weight: bold;
                    margin-top: 5px;
                }

                .cstm-main-content {
                    padding: 12px;
                    font-weight: bold;
                }

                .cstm-logo-wrapper {
                    position: relative;
                    display: block;
                    border: 5px solid #c9c9c9;
                    padding: 8px;
                    border-radius: 1px 1px 15px 1px;
                    width: 100%;
                    min-width: 180px;
                    padding-bottom: 100%;
                }

                .cstm-logo-wrapper img {
                  position: absolute;
                  width: 100%;
                  left: 0;
                  top: 0;
                  height: 100%;
                }

                .cstm-header1 {
                    background-color: #1d788f;
                    color: white;
                    padding: 10px;
                    border-radius: 0px 0px 15px 0px;
                }

                .cstm-header2 {
                    background-color: #0e518b;
                    color: white;
                    display: inline-block;
                    padding: 10px;
                    border-radius: 0px 0px 15px 0px;
                }

                .cstm-header2 a {
                    text-decoration: none;
                    color: #0e518b;
                }

                .cstm-header3 {
                    background-color: #0e518b;
                    color: white;
                    display: inline-block;
                    padding: 10px;
                    border-radius: 0px 0px 15px 0px;
                }
                
                .cstm-header3 a {
                    text-decoration: none;
                    color: #ffffff;
                }

                .cstm-footer-wrapper1 {
                    background-color: #c9c9c9;
                    position: relative;
                    display: block;
                    padding: 8px;
                }

                .cstm-footer {
                    background-color: #0e518b;
                    color: white;
                    padding: 10px;
                    border-radius: 0px 0px 15px 0px;
                }

                .cstm-footer a {
                    text-decoration: none;
                    color: white;
                }

                #header1 {
                    padding: 30px;
                    background: url(/assets/img/gray-bg.png) !important;
                    background-repeat: no-repeat !important;
                    background-size: 100% 40% !important;
                    background-position-x: 0 !important;
                    background-position-y: 73% !important;
                }

                /* New Products PDF End*/
            </style>
        </head>
        <body>

        <div class="cstm-main-content">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tbody>

                ${headerMovil}
                <tr>
                  <td colspan="3">
                    &nbsp;
                  </td>
                </tr>

                ${innerHtml}
              
                <tr>
                  <td colspan="3">
                    &nbsp;
                  </td>
                </tr>

                ${footerMovil}
                
              </tbody>
            </table>
          </div>
        </body>
        
      </html>`;
      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
      this.step = 2;
    } catch (error) {
      log.error(error);
    }
    this.isLoading = false;
  }

  checkAll(delay: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.products.forEach((obj: any) => {
          obj.isChecked = this.masterCheck;
        });
        resolve(true);
      }, delay);
    });
  }

  later(delay: number) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  public async checkMaster() {
    try {
      await this.checkAll(100);
      this.canContinueFunc();
    } catch (error) {
      log.error(error);
    }
  }

  public async canContinueFunc(ev?: any) {
    log.info(ev);
    await this.later(100);
    const array = this.products.map(e => e.isChecked);
    this.canContinue = false;
    const INDEX: number = array.indexOf(true);
    if (INDEX > -1) {
      this.canContinue = true;
    } else {
      this.canContinue = false;
    }
  }

  private getImageData(src: string): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        var image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = () => {
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          canvas.height = image.height;
          canvas.width = image.width;
          context.drawImage(image, 0, 0);
          var dataURL = canvas.toDataURL('image/jpeg');
          resolve(dataURL);
        };
        image.onerror = error => {
          reject(String(error));
        };
        image.src = src;
      } catch (error) {
        reject(String(error));
      }
    });
  }

  public async download() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      await this.platform.ready();

      await html2canvas.default(document.querySelector('#header1')).then((canvas: any) => {
        this.capturedImage = canvas.toDataURL();
      });

      if (this.platform.is('capacitor') === true) {
        await this.PDFMovil();
      } else {
        await this.PDFWeb();
      }
    } catch (error) {
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  private async PDFMovil() {
    try {
      await this.pdfGenerator.fromData(this.html, {
        type: 'share',
        documentSize: 'A4',
        fileName: this.fileName,
        landscape: 'portrait'
      });
      if (this.platform.is('android') && this.platform.is('capacitor')) {
        location.reload();
      }
    } catch (error) {
      log.error(error);
    }
  }

  private async PDFWeb() {
    try {
      var opt = {
        margin: [45, 10, 20, 10],
        filename: this.fileName,
        image: { type: 'jpg', quality: 0.9 },
        html2canvas: { scale: 2, letterRendering: true, useCORS: true },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compressPDF: true
        }
      };
      await html2pdf()
        .from(this.html)
        .set(opt)
        .toPdf()
        .get('pdf')
        .then((pdf: any) => {
          var totalPages = pdf.internal.getNumberOfPages();
          // set values x and y from footer
          let x = 52;
          let y = pdf.internal.pageSize.getHeight() - 0;
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            // set header to every page
            pdf.addImage(this.capturedImage, 'png', 0, 0, 210, 45);
            pdf.setFontSize(7);
            pdf.setTextColor(150, 150, 150);
            pdf.text(100, 10, 'Página ' + pdf.internal.getCurrentPageInfo().pageNumber + ' / ' + totalPages);
            pdf.setFontType('bold');
            pdf.setTextColor(255, 255, 255);
            pdf.textWithLink('CLICK AQUI', 8, 26, {
              url: `${environment.APP_URL}/user/details/${this.credService.credentials.uid}`
            });
            // set footer to every page
            pdf.setFontType('normal');
            pdf.setFontSize(7);
            pdf.setDrawColor(231, 232, 233);
            pdf.setFillColor(231, 232, 233);
            pdf.rect(0, y - 13.3, 70, 12, 'F');
            pdf.setDrawColor(14, 81, 139);
            pdf.setFillColor(14, 81, 139);
            pdf.rect(62, y - 11.5, 122, 9, 'F');
            pdf.setFontType('bold');
            pdf.setTextColor(255, 255, 255);
            var img =
              'data:image/png;base64,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';
            pdf.addImage(img, 'png', x - 35, y - 12, 35, 10);
            pdf.text(
              x + 13,
              y - 6,
              'PRODUCTOS PUBLICADOS EN LA PLATAFORMA CONECTIMED ' + String(environment.APP_URL).toLocaleUpperCase()
            );
          }
        })
        .save();
    } catch (error) {
      log.error('Error: ', error);
    }
  }

  refresh() {
    this.step = 1;
  }
}
